import Tag, { TTag } from './Tag';

export type { TTag };
export default Tag;
